// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconSocialFacebook = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M12.9067905,3 C10.7706953,3 9.37444398,4.30019546 9.37444398,6.65390629 L9.37444398,8.72285146 L7,8.72285146 L7,11.4375 L9.37444398,11.4375 L9.37444398,18 L12.2967692,18 L12.2967692,11.4375 L14.4757502,11.4375 L14.8905997,8.72285146 L12.2967697,8.72285146 L12.2967697,6.96123022 C12.2967697,6.21855426 12.6591064,5.49462873 13.8208013,5.49462873 L15,5.49462873 L15,3.18339872 C15,3.18339872 13.9299104,3 12.9067905,3 Z"
            />
        </svg>
    );
};

export default React.memo(IconSocialFacebook);
